import { ISort, SortType } from '@entities/util/ISort';

export const sortHandler = (sort: ISort | null, column: string): ISort | null => {
  if (sort && column === sort?.column && sort.type === SortType.ASC) {
    return {
      column,
      type: SortType.DESC,
    };
  }

  if (sort && column === sort?.column && sort.type === SortType.DESC) {
    return null;
  }

  return {
    column,
    type: SortType.ASC,
  };
};
